import {
  i18nTranslate,
  convertToBoolean,
  enableCustomizedOrderHistorySearchOption,
  getGPSConfigValue,
} from 'src/utils'
import { APPConfig } from 'config/appConfig'
export const actionState = {
  cancel: 'cancel',
  return: 'return',
}
// export const orderStatus = {
//   orderCancelled: 'Cancelled',
//   submittedToFillment: 'Submitted_to_Fulfilment',
//   shipped: 'Shipped',
//   unableToShipOrder: 'Unable_to_Ship',
//   returnSubmitted: 'Return_Submitted',
//   returnAccepted: 'Return_Accepted',
//   readyToEdit: 'Ready_To_Edit',
// }

const enableOnlineReturnMFE =
  convertToBoolean(APPConfig?.getAppConfig()?.enableOnlineReturnMFE) || false
const gpsPaymentReviewOMSStatus = getGPSConfigValue('GPSPaymentReviewOMSStatus')
// Config-driven order filter statuses
const enabledOrderFilterStatuses =
  APPConfig?.getAppConfig()?.enabledOrderFilterStatuses || []
const searchDate = [
  {
    key: i18nTranslate('orderSearch.allDates', 'All'),
    value: '',
    dataTestId: 'qa-order-all-dates',
  },

  {
    key: i18nTranslate('orderSearch.oneMonth', 'Last 1 Month'),
    value: 1,
    dataTestId: 'qa-order-last-one-month',
  },
  {
    key: i18nTranslate('orderSearch.threeMonths', 'Last 3 Months'),
    value: 3,
    dataTestId: 'qa-order-last-three-month',
  },
  {
    key: i18nTranslate('orderSearch.sixMonths', 'Last 6 Months'),
    value: 6,
    dataTestId: 'qa-order-last-six-month',
  },
  {
    key: i18nTranslate('orderSearch.twelveMonths', 'Last 12 Months'),
    value: 12,
    dataTestId: 'qa-order-last-twelve-month',
  },
  {
    key: i18nTranslate('orderSearch.twentyFourMonths', 'Last 2 Years'),
    value: 24,
    dataTestId: 'qa-order-last-two-years',
  },
  {
    key: i18nTranslate('orderSearch.thirtySixMonths', 'Last 3 Years'),
    value: 36,
    dataTestId: 'qa-order-last-three-years',
  },
  {
    key: i18nTranslate('orderSearch.fortyEightMonths', 'Last 4 Years'),
    value: 48,
    dataTestId: 'qa-order-last-four-years',
  },
  {
    key: i18nTranslate('orderSearch.SixtyMonths', 'Last 5 Years'),
    value: 60,
    dataTestId: 'qa-order-last-five-years',
  },
]
const enableCustomizedOrderHistorySearch =
  enableCustomizedOrderHistorySearchOption()
if (enableCustomizedOrderHistorySearch) {
  searchDate.push({
    key: i18nTranslate('orderSearch.seventyTwoMonths', 'Last 6 Years'),
    value: 72,
    dataTestId: 'qa-order-last-six-years',
  })
}

const shippedCompletedKey = enableOnlineReturnMFE
  ? `${i18nTranslate('orderSearch.completed', 'Completed')}`
  : `${i18nTranslate(
      'orderSearch.shipped',
      'Shipped'
    )} - ${i18nTranslate('orderSearch.completed', 'Completed')}`

// Master definitions for all possible order filter statuses
const allOrderFilterStatusDefinitions = {
  all: {
    key: i18nTranslate('orderSearch.allStatuses', 'All'),
    value: '',
    dataTestId: 'qa-order-all-statuses',
  },
  inProcess: {
    key: i18nTranslate('orderSearch.inProcess', 'In Progress'),
    value:
      'In_Process|In_Promotion_Validation|In_Inventory_Review|In_Payment_Review|In_Point_Payment_Review|In_Promotion_Assignment|In_Paypal_Payment_Review|Ready_To_Edit|Submitted_To_Fulfillment|Received_By_Fulfillment',
    dataTestId: 'qa-order-in-progress-status',
  },
  invoiced: {
    key: i18nTranslate('orderSearch.invoiced', 'Invoiced'),
    value: 'Invoiced',
    dataTestId: 'qa-order-invoiced-status',
  },
  shipped: {
    key: i18nTranslate('orderSearch.shipped', 'Shipped'),
    value: 'Shipped',
    dataTestId: 'qa-order-shipped-status',
  },
  completed: {
    key: shippedCompletedKey,
    value: 'Completed',
    dataTestId: 'qa-order-completed-status',
  },
  readyForPickup: {
    key: i18nTranslate('orderSearch.readyForPickup', 'Ready For Pickup'),
    value: 'Ready_For_Pickup',
    dataTestId: 'qa-order-ready-for-pickup-status',
  },
  cancelled: {
    key: i18nTranslate('orderSearch.cancelled', 'Cancelled'),
    value: 'Canceled',
    dataTestId: 'qa-order-cancelled-status',
  },
  returnSubmitted: {
    key: i18nTranslate('orderSearch.returnSubmitted', 'Return Submitted'),
    value: 'Return_Submitted',
    dataTestId: 'qa-order-return-submitted-status',
  },
  returned: {
    key: i18nTranslate('orderSearch.returned', 'Returned'),
    value: 'Returned',
    dataTestId: 'qa-order-returned-status',
  },
  backOrdered: {
    key: i18nTranslate('orderSearch.backOrdered', 'BackOrdered'),
    value: 'BackOrdered',
    dataTestId: 'qa-order-back-ordered-status',
  },
  paymentPending: {
    key: i18nTranslate('orderCart.paymentPending', 'Payment Pending'),
    value: gpsPaymentReviewOMSStatus,
    dataTestId: 'qa-order-payment-pending-status',
  },
}

// Build order filter status list based on config
const orderFilterStatus = enabledOrderFilterStatuses
  .filter(statusId => allOrderFilterStatusDefinitions[statusId])
  .map(statusId => allOrderFilterStatusDefinitions[statusId])

const getPaymentLabel = paymentType => {
  switch (paymentType) {
    case 'creditcard':
      return i18nTranslate('printOrder.creditCard', `Credit Card `)
    case 'debitcard':
      return i18nTranslate('printOrder.debitCard', `Debit Card `)
    case 'paypal':
      return i18nTranslate('printOrder.paypal', 'Paypal:')
    case 'alipay':
      return i18nTranslate('printOrder.alipay', 'Alipay:')
    case 'venmo':
      return i18nTranslate('printOrder.venmo', 'Venmo:')
    case 'storecredit':
      return i18nTranslate('printOrder.storeCredits', 'Store Credits:')
    case 'loyalty':
      return i18nTranslate('printOrder.loyality', 'Loyalty:')
    case 'loyaltyDiscount':
      return i18nTranslate('printOrder.loyaltyDiscount', 'Loyalty Discount:')
    default:
      return paymentType
  }
}

export { searchDate, orderFilterStatus, getPaymentLabel }
